import { createBrowserRouter } from "react-router-dom";
import App from "../components/App/App";
import YourLocation from "../pages/YourLocation/YourLocation";
import Login from "../pages/Login/Login";
import Register from "../pages/Register/Register";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import MapProvider from "../providers/MapProvider/MapProvider";
import LocationGyms from "../pages/LocationGyms/LocationGyms";
import Plans from "../pages/Plans/Plans";
import AuthProvider from "../providers/AuthProvider/AuthProvider";
import Settings from "../pages/Settings/Settings";
import PersonalInformation from "../pages/Settings/PersonalInformation/PersonalInformation";
import ChangePassword from "../pages/Settings/PersonalInformation/ChangePassword/ChangePassword";
import Account from "../pages/Settings/Account/Account";
import Contact from "../pages/Settings/Contact/./Contact";
import ErrorPage from "../pages/ErrorPage/ErrorPage";
import SuccessPage from "../pages/SuccessPage/SuccessPage";
import BillingCards from "../pages/Settings/BillingCards/BillingCards";
import SelectPlan from "../pages/SelectPlan/SelectPlan";
import YourPlan from "../pages/Settings/Account/YourPlan/YourPlan";
import ReferFriends from "../pages/Settings/ReferFriends/ReferFriends";
import HomePage from "../pages/HomePage/HomePage";
import FreeListing from "../pages/FreeListing/FreeListing";
import SelectedGym from "../pages/LocationGyms/SelectedGym/SelectedGym";
import { blogRoutes } from "./blog";
import LoyaltyPoints from "../pages/Settings/LoyaltyPoints/LoyaltyPoints";
import LoyaltyPointsHowItWorks from "../pages/Settings/LoyaltyPoints/LoyaltyPointsHowItWorks/LoyaltyPointsHowItWorks";
import SavedPlaces from "../pages/Profile/SavedPlaces/SavedPlaces";
import Profile from "../pages/Profile/Profile";
import Attended from "../pages/Profile/Attended/Attended";
import RecentChargesLayout from "../pages/Settings/RecentChargesLayout/RecentChargesLayout";
import RecentCharges from "../pages/Settings/RecentChargesLayout/RecentCharges/RecentCharges";
import PurchaseHistory from "../pages/Settings/RecentChargesLayout/PurchaseHistory/PurchaseHistory";
import Upcoming from "../pages/Profile/Upcoming/Upcoming";
import { PrivacyPolicy } from "../pages/PrivacyPolicy/PrivacyPolicy";
import LocationGymClasses from "../pages/LocationGymClasses/LocationGymClasses";
import CancelSubscription from "../pages/Settings/Account/YourPlan/CancelSubscription/CancelSubscription";

const index = createBrowserRouter([
  {
    path: "",
    element: <App />,
    children: [
      { path: "", element: <HomePage /> },
      {
        path: "free-listing",
        element: (
          <MapProvider>
            <FreeListing />
          </MapProvider>
        ),
      },
      {
        path: "gyms-location",
        element: (
          <MapProvider>
            <LocationGyms />
          </MapProvider>
        ),
      },
      {
        path: "gyms-location/:id",
        element: (
          <MapProvider>
            <SelectedGym />
          </MapProvider>
        ),
      },
      {
        path: "gyms-location/:id/classes",
        element: (
          <MapProvider>
            <LocationGymClasses />
          </MapProvider>
        ),
      },
      { path: "login", element: <Login /> },
      { path: "register", element: <Register /> },
      { path: "forgot-password", element: <ForgotPassword /> },
      { path: "select-plan", element: <SelectPlan /> },
      {
        path: "your-location",
        element: (
          <MapProvider>
            <YourLocation />
          </MapProvider>
        ),
      },
      {
        path: "settings",
        element: (
          <AuthProvider>
            <Settings />
          </AuthProvider>
        ),
        children: [
          { path: "account", element: <Account /> },
          { path: "account/manage-plan", element: <YourPlan /> },
          { path: "account/manage-plan/cancel", element: <CancelSubscription /> },
          { path: "personal-information", element: <PersonalInformation /> },
          { path: "personal-information/change-password", element: <ChangePassword /> },
          { path: "billing-cards", element: <BillingCards /> },
          { path: "contact", element: <Contact /> },
          {
            path: "recent-charges",
            element: <RecentChargesLayout />,
            children: [
              { index: true, element: <RecentCharges /> },
              { path: "purchase-history", element: <PurchaseHistory /> },
            ],
          },
          { path: "refer-friends", element: <ReferFriends /> },
          { path: "loyalty-points", element: <LoyaltyPoints /> },
          { path: "loyalty-points/how-it-works", element: <LoyaltyPointsHowItWorks /> },
        ],
      },
      {
        path: "profile",
        element: (
          <AuthProvider>
            <Profile />
          </AuthProvider>
        ),
        children: [
          { path: "upcoming", element: <Upcoming /> },
          { path: "attended", element: <Attended /> },
          { path: "saved-places", element: <SavedPlaces /> },
        ],
      },
      { path: "plans", element: <Plans /> },
      { path: "success", element: <SuccessPage /> },
      { path: "/privacy-policy", element: <PrivacyPolicy /> },
      ...blogRoutes,
      { path: "/*", element: <ErrorPage /> },
    ],
  },
]);

export default index;
